import React from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { stringify } from "query-string"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import KflSubCategoryCard from "./KflSubCategoryCard"
import classes from "./index.module.scss"

const KfSubCategories = (props) => {
  const {
    selectedCategory,
    selectedSubCategory,
    setSelectedSubCategory
  } = props

  const history = useHistory()

  const [t] = useTranslation()

  const branchId =
    useSelector(state => state.userAccountInfo.branchId)

  const categories =
    useSelector(state => state.categories)
      .filter(category =>
        category.branchIds.includes(branchId)
      )

  const handleClick = () => {
    if (selectedSubCategory === null) return

    setSelectedSubCategory(null)

    const newQueries = {
      categoryId: selectedCategory._id,
      subCategoryId: ""
    }

    history.push(`/kiosk-foods?${stringify(newQueries, { skipEmptyString: true })}`)
  }

  const subCategories =
    !!selectedCategory
      ? categories.filter(category => category.parentId === selectedCategory._id)
      : []

  if (subCategories.length === 0) return null

  return (
    <div className={classes["row"]}>
      <button
        onClick={handleClick}
        className={clsx(
          classes["button"],
          selectedSubCategory === null && classes["active"]
        )}
      >
        {t("همه")}
      </button>

      {subCategories.map(subCategory =>
        <KflSubCategoryCard
          key={subCategory._id}
          subCategory={subCategory}
          selectedCategory={selectedCategory}
          selectedSubCategory={selectedSubCategory}
          setSelectedSubCategory={setSelectedSubCategory}
        />
      )}
    </div>
  )
}

export default KfSubCategories